import { render } from "./ChartPage.vue?vue&type=template&id=66c1def9"
import script from "./ChartPage.vue?vue&type=script&lang=js"
export * from "./ChartPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__